export const getAccessToken = 'VF1_LOGIN_INFO';
export const getSoDetail = 'VF1_SO_DETAIL';
export const vf1Logout = 'VF1_LOGOUT';

const INITIAL_STATE = {
    accessToken: '',
    accessTokenExpired: new Date().getTime(),
    soId: '',
    soDetail: {},
};

const ACTION_HANDLERS = {
    [getAccessToken]: (state, payload) => ({
        ...state,
        accessToken: payload.token,
        accessTokenExpired: payload.expired,
        soId: payload.soId,
    }),
    [getSoDetail]: (state, payload) => ({
        ...state,
        soDetail: payload,
    }),
    [vf1Logout]: () => INITIAL_STATE,
};


export default (state = INITIAL_STATE, { type, payload }) => {
    const fn = ACTION_HANDLERS[type];
    if (typeof fn === 'function') {
        return fn(state, payload);
    }
    return state;
};
